import { Image } from "antd"
import View from "../Base/View"
import Text from "../Base/Text"
import Price from "../Price"
import './index.scss'

const Cartitem = (prop: {
    className: string,
    productInfo: any,//商品信息
    selected: boolean,//是否选中
    onItemclickevent: () => void,
    onCountaddevent: () => void,
    onCountsubevent: () => void,
    onSelectclickevent: () => void,
    onDeleteevent: () => void,
    onCountmodiftevent: () => void,
}) => {
    return <View className={`cart-item-container ${prop.className || ''}`} onClick={(e)=>{
        e.stopPropagation();
        prop.onItemclickevent()
    }}>
        <View className="cart-item-inner">
        <Image preview={false} className="product-select-radio"
            src={require(`../../images/cart-${prop.productInfo.Warnings && prop.productInfo.Warnings.length > 0 ? 'disable' : (prop.selected ? 'select' : 'unselect')}.png`)}
            onClick={(e) => {
                e.stopPropagation();
                prop.onSelectclickevent()
            }}></Image>
        <Image preview={false} className="product-thumb" src={prop.productInfo.PictureUrl}></Image>
        <View className="product-meta">
            <Text className="product-name">{prop.productInfo.ProductName}</Text>
            <Text className="product-type">{prop.productInfo.AttributeInfo}</Text>
            <View className="product-price-and-tunnel">
                <View className="product-price"><Price value={prop.productInfo.UnitPriceStr} size={26} style={{
                    fontWeight:"bold"
                }}></Price></View>
                <View className="product-count-info" onClick={(e) => {
                    e.stopPropagation();
                    prop.onCountmodiftevent()
                }}>
                    <Image preview={false} className="product-count-tunel product-count-del"
                        src={require(`../../images/count-del${prop.productInfo.Quantity > prop.productInfo.MinProductQuantity ? '' : '-disable'}.png`)}
                        onClick={(e) => {
                            e.stopPropagation();
                            prop.onCountsubevent()
                        }}></Image>
                    <Text className="product-select-count">{prop.productInfo.Quantity}</Text>
                    <Image preview={false} className="product-count-tunel product-count-add"
                        src={require(`../../images/count-add${prop.productInfo.Quantity < prop.productInfo.MaxProductQuantity ? '' : '-disable'}.png`)}
                        onClick={(e) => {
                            e.stopPropagation();
                            prop.onCountaddevent();
                        }}></Image>
                </View>
            </View>
        </View>
        </View>
        
        {prop.productInfo.Warnings && prop.productInfo.Warnings.length > 0 && <View
            className="returnable-tips-container">
            {prop.productInfo.Warnings.map((w: string) => {
                return <View key={w} className="returnable-tips">
                    <Image preview={false} className="returnable-tips-icon" src={require(`../../images/cart-warning.png`)}></Image>
                    <text>{w}</text>
                </View>
            })}
        </View>}
        <Image preview={false} wrapperClassName="product-delete" src={require(`../../images/cart-delete.png`)} onClick={(e)=>{
            e.stopPropagation();
            prop.onDeleteevent()
        }}></Image>
    </View>
}

export default Cartitem